import {Injectable} from '@angular/core';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {Router} from '@angular/router';
import {FormFieldTextboxSupplier} from '../../suppliers/form-field-textbox-supplier';
import {GenericHandler} from '../generics/generic-handler';
import {UtilsService} from '../../utils/utils.service';
import {FormFieldCheckboxSupplier} from '../../suppliers/form-field-checkbox-supplier';
import {Title} from '@angular/platform-browser';
import {Auth2Service} from '../security/auth2.service';
import {HttpClient} from '@angular/common/http';
import {SecteurDTO} from '../../dtos/secteur-dto';
import {DialogMsgSupplier, Paragraphe} from '../../suppliers/dialog-msg-supplier';
import {ObjectDTO} from '../../dtos/object-dto';
import {startCase as _startCase} from 'lodash';
import {GenericDatagridService} from '../generics/generic-datagrid.service';

@Injectable()
export class SecteursService extends GenericHandler<SecteurDTO> {


  secteurEnvironnement:SecteurDTO[]=[];

  getTotalRecordsLabel(): string {
    return _startCase(this.getEntityName());
  }


  getHelp() : DialogMsgSupplier {
    let dms = new DialogMsgSupplier();
    dms.title = `Les secteurs`;
    dms.logo = 'fa fa-question-circle  yoni-color';

    let p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
      ` Un secteur permet de rattacher des fournisseurs avec des unités de production.`,
    ];

    dms.content = {
      intro: `Les secteurs se paramètrent par site.`,
      paragraphes: [p1]

    };


    return dms;
  }



  getSort(): string[] {
    return ['code,asc'];
  }

  getOas(): boolean {
    return undefined;
  }

  getTitle(): string {
    return 'GESTION DES SECTEURS';
  }

  getCreateNewObjectLabel(): string {
    return 'CRÉER UN SECTEUR';
  }

  getEntityName(): string {
    return 'Secteur';
  }

  constructor(utils: UtilsService, auth2Svc: Auth2Service, router: Router, http: HttpClient,title:Title, private gds:GenericDatagridService){
    super(utils, auth2Svc, router, http,title);

    this.getAllFromEnvironnement();

    this.environnement$.subscribe(() => {
      this.getAllFromEnvironnement();
    });
  }

  getFields(dto: SecteurDTO): FormFieldBaseSupplier<any>[] {

    // Par défaut une Secteur est actif.
    if(this.utils.isNullOrEmpty(dto) || dto.id == 0 || dto.id == undefined) {
      dto = new SecteurDTO();
      dto.actif = true;
    }

    let formFields: FormFieldBaseSupplier<any>[] = [

      this.createFormFieldBaseSupplierForSite(dto, 1),


      new FormFieldTextboxSupplier({
        key: 'libelle',
        label: 'Libellé',
        readonly: !this.canModify(dto),
        minLength: 2,
        maxLength: 100,
        excelType:'string',
        value: dto.libelle,
        required: true,
        order: 2
      }),


      new FormFieldTextboxSupplier({
        key: 'code',
        label: 'Code',
        excelType:'string',
        readonly: !this.canModify(dto),
        minLength: 1,
        maxLength: 50,
        value: dto.code,
        required: true,
        order: 3
      }),



      new FormFieldCheckboxSupplier({
        key: 'actif',
        label: 'Actif',
        excelType:'boolean',
        readonly: !this.canModify(dto),
        value: dto.actif,
        required: false,
        order: 5
      }),

      new FormFieldTextboxSupplier({
        key: 'id',
        type: 'hidden',
        value: dto.id,
        order: 6
      })

    ];

    return formFields.sort((a, b) => a.order - b.order);
  }



  getAllFromEnvironnement(): void {
    this.gds.getAll(this.getEntityName(), ['libelle,asc'], true)
      .subscribe(response => {
        this.secteurEnvironnement = [];

        if (!this.utils.isCollectionNullOrEmpty(response.resultList)) {
          this.secteurEnvironnement = response.resultList.map(item => {
            item.libelle = item.libelle.toUpperCase();
            return item;
          });
        }

        this.announceObjects(this.secteurEnvironnement);

      });
  }

  createEmptyDTO(): SecteurDTO {
    return new SecteurDTO();
  }

  getEditObjectLabel(data: ObjectDTO): string {
    return `MODIFIER LE SECTEUR '${data.libelle.toUpperCase()}'`;
  }
}
